/**
 * Page-level delegate for the Configuration orchestrator.
 *
 * Only owns state that is genuinely page-wide: loading, error,
 * notification, and the `firstTimeSetup` flag. Per-tab state lives in
 * each tab controller's own internal state, written through their own
 * delegates.
 */
class ConfigurationDelegate {
    setLoading(loading) {
        this.setState({ loading });
    }

    setError(error) {
        this.setState({ error });
    }

    setFirstTimeSetup(firstTimeSetup) {
        this.setState({ firstTimeSetup });
    }

    showNotification(type, message, description = '') {
        this.setState({
            notification: { show: true, type, message, description }
        });

        // Auto-hide after 4s. Stored in a ref-less timer so subsequent
        // notifications simply replace the visible one.
        setTimeout(() => {
            this.setState((prevState) => ({
                notification: { ...prevState.notification, show: false }
            }));
        }, 4000);
    }
}

export default ConfigurationDelegate;
